"use client";
import { useTranslations, useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useWorkspace } from "@/contexts/workspace-context";
import { useAuth } from "@/contexts/auth-context";
import { Button } from "@/components/ui/button";
import { nativeSelectClass } from "@/components/ui/native-select";
import { cn } from "@/lib/utils";

export function WorkspaceSelector() {
  const t = useTranslations("workspace");
  const locale = useLocale();
  const router = useRouter();
  const { isAuthenticated } = useAuth();
  const { workspaces, selected, select, loading, error, refresh, hasMore, loadMore } = useWorkspace();
  if (!isAuthenticated) return null;
  return <section className="flex flex-wrap items-center gap-2 border-b p-3" aria-label={t("title")}>
    <label htmlFor="workspace-selector" className="text-sm font-medium">{t("title")}</label>
    <select id="workspace-selector" value={selected?.domain_id ?? ""} disabled={loading}
      className={cn(nativeSelectClass,"w-auto max-w-full")}
      onChange={e => { select(e.target.value); router.replace(`/${locale}/runs`); }}>
      <option value="">{loading ? t("loading") : t("choose")}</option>
      {workspaces.map(row => <option key={row.domain_id} value={row.domain_id}>{row.organization_name} / {row.tenant_name} / {row.domain_name}</option>)}
    </select>
    <Button size="sm" variant="outline" onClick={refresh} disabled={loading}>{t("refresh")}</Button>
    {hasMore && <Button size="sm" variant="outline" onClick={loadMore} disabled={loading}>{t("more")}</Button>}
    {error && <p role="alert" className="text-sm text-destructive">{t("unavailable")}</p>}
    {!loading && !error && workspaces.length === 0 && <p role="status" className="text-sm text-muted-foreground">{t("empty")}</p>}
  </section>;
}
